import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { kc } from "../pricing";

export default function ConfirmationPage() {
  const { state } = useLocation();
  const order = state && state.order;
  const [shareMsg, setShareMsg] = useState(null);

  if (!order) {
    return (
      <div className="card">
        <h1>Objednávka</h1>
        <p>Žádná objednávka k zobrazení.</p>
        <Link to="/">Zpět do obchodu</Link>
      </div>
    );
  }

  const pay = order.payment || {};
  const qrUrl = pay.qr_spayd
    ? `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(pay.qr_spayd)}`
    : null;
  const payText =
    `Platba za objednávku #${order.id}\n` +
    `Účet: ${pay.account || ""}\n` +
    `Částka: ${kc(order.total)} Kč\n` +
    `Variabilní symbol: ${pay.variable_symbol}`;

  // klik na QR / tlačítko → systémové sdílení (na telefonu nabídne bankovní app atd.)
  async function shareQr() {
    setShareMsg(null);
    try {
      // 1) zkus sdílet obrázek QR jako soubor (nejlepší pro „sdílet do banky")
      if (qrUrl && navigator.canShare) {
        try {
          const resp = await fetch(qrUrl);
          const blob = await resp.blob();
          const file = new File([blob], `qr-platba-${order.id}.png`, { type: blob.type || "image/png" });
          if (navigator.canShare({ files: [file] })) {
            await navigator.share({ files: [file], title: "QR platba — Ponožky", text: payText });
            return;
          }
        } catch (_) { /* spadne na sdílení textu */ }
      }
      // 2) sdílení textu s platebními údaji
      if (navigator.share) {
        await navigator.share({ title: "Platba — Ponožky", text: payText });
        return;
      }
      // 3) fallback: zkopíruj údaje do schránky
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(payText);
        setShareMsg("Platební údaje zkopírovány do schránky.");
        return;
      }
      setShareMsg("Sdílení není v tomto prohlížeči podporováno — opiš údaje výše.");
    } catch (_) {
      setShareMsg("Sdílení se nepodařilo — opiš prosím údaje výše.");
    }
  }

  return (
    <div className="card confirmation">
      <h1>✅ Děkujeme za objednávku #{order.id}</h1>
      <div className="summary">
        {(order.items || []).map((it, i) => (
          <div key={i} className="item-row">
            <span>vel. {it.variant_label} — {it.quantity}× {kc(it.unit_price)} Kč</span>
            <span>{kc(it.quantity * it.unit_price)} Kč</span>
          </div>
        ))}
        <div><span>Mezisoučet</span><span>{kc(order.subtotal)} Kč</span></div>
        <div><span>Doprava</span><span>{kc(order.shipping_cost)} Kč</span></div>
        {order.other_amount > 0 && (
          <div><span>Dýško pro Evu a Ditu</span><span>{kc(order.other_amount)} Kč</span></div>
        )}
        <div className="total"><span>Celkem</span><span>{kc(order.total)} Kč</span></div>
      </div>

      {order.announcement && (
        <div className="announcement-box">{order.announcement}</div>
      )}

      {pay.method === "BANK_TRANSFER" ? (
        <div className="pay-box">
          <h2>Platební instrukce</h2>
          <p>Zaplať prosím převodem:</p>
          <ul>
            <li>Účet: <strong>{pay.account || "—"}</strong></li>
            <li>Variabilní symbol: <strong>{pay.variable_symbol}</strong></li>
            <li>Částka: <strong>{kc(order.total)} Kč</strong></li>
          </ul>
          {qrUrl && (
            <div className="qr-pay">
              <button type="button" className="qr-btn" onClick={shareQr} title="Sdílet platbu">
                <img src={qrUrl} alt="QR platba" width="220" height="220" />
              </button>
              <button type="button" className="btn-block" onClick={shareQr}>📤 Sdílet platbu / zaplatit</button>
              <p className="muted small">Na telefonu klikni na QR nebo tlačítko — nabídne sdílení do bankovní aplikace. Nebo QR naskenuj v bance.</p>
              {shareMsg && <p className="small">{shareMsg}</p>}
            </div>
          )}
        </div>
      ) : (
        <div className="pay-box">
          <h2>Platba hotově</h2>
          <p>Domluvíme předání a platbu osobně.</p>
        </div>
      )}

      <Link className="btn-link" to="/">Zpět do obchodu</Link>
    </div>
  );
}
